import type { ModalSheetConfig } from 'src/components/contexts/ModalSheetContext'
import { Image } from 'src/components/ui/Image'
import { formatTableData } from 'src/utils/pdp/formatTableData'
import type { Product } from 'src/components/restructure/product/types/product'

export function getSizeGuideModalConfig(
  product: Product,
  isMobile = false
): ModalSheetConfig | null {
  if (!product?.sizeDetails) {
    return null
  }

  const {
    how_to_measure: { title, subtitle, description, imageUrl },
    how_to_measure_details: howToMeasureDetails,
    conception_sizes_details: {
      conception_size_parameters: conceptionSizeParameters,
    },
  } = product.sizeDetails

  const { tableHeaderX, tableHeaderY } = formatTableData(
    conceptionSizeParameters
  )

  const ModalContent = () => (
    <div className="m-6 mt-0">
      <div className="size-guide-table-wrapper my-6 overflow-x-auto w-full">
        <table className="size-guide-table text-sm w-full mb-8">
          <thead>
            <tr>
              <th className="w-[113px]"> </th>
              {tableHeaderX.map((label, i) => (
                <th key={`${label}-${i}`} className="font-bold w-[152px]">
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableHeaderY.map((label, i) => {
              const rowData = conceptionSizeParameters.map(
                ({ sizes }) => sizes.filter((size) => size.label === label)[0]
              )

              return (
                <tr
                  key={`${label}-${i}`}
                  className="last:border-b-0 border-y border-gray"
                >
                  <td>{label}</td>
                  {rowData.map(({ value }) => (
                    <td key={`${value}`}>{value}</td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {tableHeaderX.length > 3 && (
        <span className="text-tertiary text-sm mb-10">
          Arraste para o lado para ver mais
        </span>
      )}

      <div className="mt-12">
        <span className="text-xl sm:text-2xl font-medium">{subtitle}</span>
        <p className="mt-4 mb-10 text-secondary">{description}</p>

        <Image
          src={imageUrl}
          width={isMobile ? 327 : 437}
          height={isMobile ? 327 : 437}
          alt="Como medir"
        />

        <div className="mt-10">
          {howToMeasureDetails.map(({ label, value }, i) => (
            <p key={`${label}-${i}`} className="first:mt-0 last:mb-0 my-5">
              <b>{label}:</b> {value}
            </p>
          ))}
        </div>
      </div>
    </div>
  )

  return {
    content: <ModalContent />,
    title,
    height: '90vh',
  }
}
